import React, { useEffect, useState } from "react";
import { Card, Row, message, Button, Table, Spin, Typography, Modal } from "antd";
import { DeleteOutlined, InfoCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import { Link } from "react-router-dom";

const { Title } = Typography;

const ContactList = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = async () => {
    try {
      setLoading(true);
      const response = await axios.get("http://93.127.203.113:5005/contact");
      setContacts(response.data);
    } catch (error) {
      message.error("Failed to load contact requests.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`http://93.127.203.113:5005/contact/${id}`);
      message.success("Contact request deleted successfully.");
      fetchContacts();
    } catch (error) {
      message.error("Failed to delete contact request.");
    }
  };

  const columns = [
    { title: "Full Name", dataIndex: "fullName", key: "fullName" },
    { title: "Email", dataIndex: "email", key: "email" },
    { title: "Message", dataIndex: "message", key: "message", ellipsis: true },

    {
      title: <span style={{ fontWeight: "bold", color: "#0c8c49" }}>Actions</span>,
      key: "actions",
      render: (_, record) => (
        <>
          {/* View Details */}
          <Link to={`/contactDetails/${record.id}`} style={{ color: "#0c8c49", marginRight: 10 }}>
            <InfoCircleOutlined /> Details
          </Link>

          {/* Delete Button */}
          <Button type="link" icon={<DeleteOutlined />} onClick={() => handleDelete(record.id)} danger>
            Delete
          </Button>
        </>
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <Card style={{ borderRadius: "10px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
        <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
          Contact Requests
        </Title>
        {loading ? <Spin size="large" /> : <Table columns={columns} dataSource={contacts} rowKey="id" />}
      </Card>
    </div>
  );
};

export default ContactList;
